// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2mBri","label":"CategoryService_label__3eQek","location":"CategoryService_location__seg5E"};